import React from 'react'
import { Card, CardContent } from '@material-ui/core'
import moment from 'moment'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import Fade from '@material-ui/core/Fade'
import hybrid from '@src/assets/hybrid.png'
import roadmap from '@src/assets/roadmap.png'
import berkadia_style from '@src/assets/berkadia_style.jpg'
import blue_tint from '@src/assets/blue_tint.jpg'
import earthly_view from '@src/assets/earthly_view.jpg'
import gray_scale from '@src/assets/gray_scale.jpg'
import gray_scale_with_water from '@src/assets/gray_scale_with_water.jpg'
import map_and_terrain from '@src/assets/map_and_terrain.jpg'
import './MapProjectCardItem.scss'

const useStyles = makeStyles(theme => ({
    root: {
        minWidth: 252,
        background: '#FFFFFF',
        borderRadius: 1,
        color: '#5E6C84',
        '&:hover': {
            boxShadow: '0px 10px 30px rgba(0, 0, 0, 0.17)',
            transition: theme.transitions.create('transform', {
                duration: theme.transitions.duration.shortest
            })
        }
    },
    editIcons: {
        color: '#5E6C84'
    }
}))

const MapProjectCardItem = props => {

    const classes = useStyles()
    const { index, property } = props
    let { street } = property
    street = (street === '') ? `${property.city}, ${property.state}` : street
    const getMapImage = mapType => {
        switch (mapType) {
            case 'hybrid':
                return hybrid
            case 'berkadia-style':
                return berkadia_style
            case 'blue-tint':
                return blue_tint
            case 'earthly-view':
                return earthly_view
            case 'gray-scale':
                return gray_scale
            case 'gray-scale-with-water':
                return gray_scale_with_water
            case 'terrain':
                return map_and_terrain
            default:
                return roadmap
        }
    }

    const handleOnClick = () => {
        window.open(`${process.env.REACT_APP_MAPS_APP_URL}/${property.map_guid}`, '_blank')
    }

    return (
        <Fade in={true} timeout={500}>
            <div className="project-card" >
                <Card className={classes.root} variant="outlined" key={index} elevation={3} data-testid={`map-card-content-${index}`} onClick={handleOnClick}>
                    <CardContent className="cardContentAllProjects">
                        <div>
                            <img className="propertyMapIcon" src={getMapImage(property.mapType)} width="45px" height="40px" />
                        </div>
                        <div className="propertyDetails">
                            <div className="cardElipsis">
                                <span className="boldTextName">{property.map_name}</span>
                                <br />
                                <span className="grayTextColor">{street}</span>
                            </div>
                        </div>
                        <div>
                            <span className="boldText">{property.deal_number ? property.deal_number : ''}</span>
                            <br />
                            <span className="grayTextColor">Deal ID</span>
                        </div>
                        <div>
                            <span className="boldText">{property.properties_count}</span>
                            <br />
                            <span className="grayTextColor">Properties</span>
                        </div>
                        <div>
                            <span className="boldText" id={`owner-cell-${index}`}>{property.created_user_name}</span>
                            <br />
                            <span className="grayTextColor">Owned by</span>
                        </div>
                        <div>
                            <span className="boldText">{moment(property.modified_date).format('ll')}</span>
                            <br />
                            <span className="grayTextColor">Modified</span>
                        </div>
                    </CardContent>
                </Card>
            </div>
        </Fade>
    )
}

MapProjectCardItem.propTypes = {
    index: PropTypes.number,
    property: PropTypes.shape({
        map_guid: PropTypes.string,
        map_name: PropTypes.string,
        created_entity_user_guid: PropTypes.string,
        modified_date: PropTypes.string,
        properties_count: PropTypes.number,
        street: PropTypes.string,
        no_street: PropTypes.array,
        mapType: PropTypes.string,
        created_user_name: PropTypes.string
    })
}

export default MapProjectCardItem
